import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import $ from "jquery";
import axios from "axios";
import 'bootstrap-daterangepicker/daterangepicker.css';
import {connect}  from  "react-redux";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, unauthorize_access, user_activities } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import TenderModeFilter from '../../filters/TenderModeFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import DistinctValueFilter from '../../filters/DistinctValueFilter.jsx';

var date_config = date_range_config('1', '1', '2020-02-01','1');
var hdfcSttlTable='';

class HdfcSettlementReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            ciutidIds: '',
            tenderModeIDs:'',
            statusIDs: [],
            businessLineIDs: [],
            statusOptions: [],
            businessLineOptions: [],
            isChange: false,
            state_code:'',
            object_code:[],
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        // isReportAccess(AllAccessPermissions, 'hdfc_settlement_report');
        isReportAccess(AllAccessPermissions, 'fund_transfer_settlement');
        if(decoded.object_type==='Merchant'){
            this.setState({ merchantID: arrayCode });
        }
        if(decoded.object_type==='Chain'){
            this.setState({ chainID: arrayCode });
        }
        if(decoded.object_type==='Store'){
            this.setState({ storeID: arrayCode });
        }
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
        if(decoded.userGroupName==='Meta Users')
        {
            if(decoded.object_type==='Innoviti')
            {
                var state_code = localStorage.state_code;
                if(state_code=='' || state_code=='null' || state_code==null || state_code==undefined) {
                    this.setState({ state_code: '' });
                } else {
                    var state_arr = state_code.split(",");
                    this.setState({ state_code: state_arr });
                }
            } else {
                unauthorize_access();
            }
        }
    }

    componentDidMount() {
        this.fetchFilterOptions();
        this.get_filtered_hdfc_settle_report(this.state.object_type,this.state.object_code,'');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'hdfc_settlement_report','sparcs')
    }

    fetchFilterOptions() {
        axios.get(config.get('API_URL') + '/summaryReport/hdfc-filter-options', {
            headers: { Authorization: ` ${localStorage.usertoken}` }
        }).then(response => {
            const data = (response.data && response.data.data) || {};
            this.setState({
                statusOptions: Array.isArray(data.status) ? data.status : [],
                businessLineOptions: Array.isArray(data.business_line) ? data.business_line : [],
            });
        }).catch(err => { console.log(err); });
    }

    downloadHdfcSettlReportCheck(e){
        let filters = {
            store_codes: this.state.storeID,
            acq_bank_codes: this.state.acqBankIds,
            status: this.state.statusIDs,
            business_line: this.state.businessLineIDs,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            tender_mode: this.state.tenderModeIDs,
            utid: this.state.ciutidIds,
            download: 1,
        };
        this.setState({ filters: filters });
        const noFilters = this.state.storeID === '' && this.state.ciutidIds === '' && this.state.acqBankIds === ''
            && (!this.state.statusIDs || this.state.statusIDs.length === 0)
            && (!this.state.businessLineIDs || this.state.businessLineIDs.length === 0)
            && (!this.state.tenderModeIDs || this.state.tenderModeIDs === '');
        if (noFilters) {
            confirmAlert({
                message: "Do you really want to download all data for date range: " + this.state.datefromShow + " - " + this.state.dateToShow + " ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.refs.downloadAllReport.downLoadReport(filters, '/report/settlement/hdfc', 'hdfc_settlement_report', -1);
                    }
                },
                { label: 'Cancel' }
                ]
            });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/report/settlement/hdfc', 'hdfc_settlement_report', -1);
        }
    }

    get_filtered_hdfc_settle_report(object_type, object_code, event) {
        var that = this;
        var stores = this.state.storeID;

        isApiResponse(false);

        if (object_type === 'Store' && this.state.storeID === '') { stores = object_code; }

        var postData = {
            sids: stores,
            bids: this.state.acqBankIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            status: this.state.statusIDs,
            business_line: this.state.businessLineIDs,
            utid: this.state.ciutidIds,
            tender_mode: this.state.tenderModeIDs,
        };
        if ($.fn.DataTable.isDataTable('#hdfcSttlTable')) {
            $('#hdfcSttlTable').DataTable().clear().destroy();
        }
        hdfcSttlTable = $('#hdfcSttlTable').DataTable({
            order: [],
            "processing": true,
            "serverSide": true,
            "bDestroy": true,
            "paging": true,
            "pageLength": 20,
            "bInfo": false,
            "sPaginationType": "numbers",
            "responsive": false,
            "scrollX": true,
            "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],
            ajax: {
                url: config.get('API_URL') + "/summaryReport/hdfc-settlement",
                type: "POST",
                data: postData,
                dataSrc: function (json) {
                    isApiResponse(true);
                    that.setState({ isChange: false });
                    return json.data;
                },
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                error: function (data) {
                    isApiResponse(true);
                    alert("Failed to load data. Please try again");
                },
                complete: function (data) {
                    isApiResponse(true);
                },
            },
            columns: [
                {"data": "Store Name", "width": "180px"},
                {"data": "UTID"},
                {"data": "Card Type"},
                {"data": "Card Logo"},
                {"data": "Tender Mode"},
                {"data": "Business Line"},
                {"data": "AcqBankCode"},
                {"data": "Acquiring Bank"},
//                 {"data": "Issuer Bank"},
                {"data": "Txn Timestamp"},
                {"data": "Edc Amount"},
                {"data": "Txn Amount"},
                {"data": "MDR"},
                {"data": "MDR Amount"},
                {"data": "GST On MDR"},
                {"data": "Processing Fee Amount"},
                {"data": "GST On Proc Fee"},
                {"data": "EMI Processing Fee"},
                {"data": "GST On EMI Fee"},
                {"data": "EMI Instant Discount"},
                {"data": "Chargeback Amount"},
                {"data": "Rent Amount"},
                {"data": "GST On Rent Amount"},
                {"data": "Rental Charge Amount"},
                {"data": "Bank Received Amount"},
                {"data": "Final Txfr Amount"},
                {"data": "Commission"},
                {"data": "Narration"},
                {"data": "Chq/RefNo"},
                {"data": "beneficiary_status"},
                {"data": "status"},
                {"data": "Settlement Datetime"},
                {"data": "Installation Fee"},
                {"data": "Transaction Amount"},
                {"data": "Bank MPR"},
                {"data": "Bank Amount"},
                {"data": "bankdiff"},
                {"data": "txn_timestamp"},
                {"data": "remarks"},
                {"data": "adjustment_amount"},
                {"data": "cardtype"},
                {"data": "CRISP Status"},
                {"data": "Genie Cash Rate"},
                {"data": "Genie Cash Fee"},
                {"data": "GST on Genie Cash Fee"},
                {"data": "Innoviti Convenience Fee"},
                {"data": "card_category"},
                {"data": "mdr_cost"},
                {"data": "mdr_cost_rate_percentage"},
            ],
            "columnDefs": [
                {
                    render: function (data, type, full, meta) {
                        if (data === null || data === '' || data === 'null') {
                            data = '';
                        }
                        return "<div class='text-wrap width-150'>" + data + "</div>";
                    },
                    "targets": [0]
                }
            ]
        });
    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }

        this.refs.tenderModeFilter.restTenderModeFilter();
        this.refs.statusFilter.resetFilter();
        this.refs.businessLineFilter.resetFilter();
        this.refs.acquirerFilter.resetAcquirerFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            ciutidIds: '',
            statusIDs: [],
            businessLineIDs: [],
            isChange: false,
            tenderModeIDs:'',
        });

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }

    handleDateRange = (todSend, yestSend, datefromShow, dateToShow) => {
        this.setState({ todSend, yestSend, datefromShow, dateToShow, isChange: true });
    }
    handleStatus = (statusIDs) => {
        this.setState({ statusIDs, isChange: true });
    }
    handleBusinessLine = (businessLineIDs) => {
        this.setState({ businessLineIDs, isChange: true });
    }
    handleStore = (storeID) => {
        this.setState({ storeID, isChange: true, ciutidIds: '' });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) => {
        this.setState({ ciutidIds:utid, isChange: true });
    }
    handleTenderMode = (optionSelected, tenderModeIDs) => {
        this.setState({ tenderModeIDs, isChange: true });
    }
    handleAcquirer = (optionSelected, acqBankIds) => {
        this.setState({ acqBankIds, isChange: true });
    }

    render() {
        return (
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">HDFC Settlement Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu"></div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right" style={{display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start'}}>
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate={this.handleDateRange} start_date={this.state.datefrom} end_date={this.state.dateTo} display_start_date={this.state.datefromShow} display_end_date={this.state.dateToShow}
                                                    start_date_limit={this.state.dateFromLimit} end_date_limit={this.state.dateLimit}/>
                                            </div>
                                            {this.state.object_type === 'Innoviti' || this.state.object_type === 'Merchant' || this.state.object_type === 'Chain' ?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Store: </label>
                                                    <StoreFilter ref="reloadStore" onSelectStore={this.handleStore} object_type={this.state.object_type} object_code={this.state.object_code} user_type={this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Utid: </label>
                                                <UtidFilter ref="reloadUtid" onSelectUtid={this.handleUtid} object_type={this.state.object_type} object_code={this.state.object_code} user_type={this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Acquirer:</label>
                                                <AcquirerFilter ref="acquirerFilter" onSelectAcquirer={this.handleAcquirer}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Status </label>
                                                <DistinctValueFilter ref="statusFilter" name="status" placeholder="All" options={this.state.statusOptions} onSelect={this.handleStatus}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Business Line </label>
                                                <DistinctValueFilter ref="businessLineFilter" name="business_line" placeholder="All" options={this.state.businessLineOptions} onSelect={this.handleBusinessLine}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Tender Mode </label>
                                                <TenderModeFilter ref="tenderModeFilter" onSelectTenderMode={this.handleTenderMode}/>
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange === true ?
                                                <span className="apply-notification">Please click on Apply button</span> : null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_hdfc_settle_report.bind(this, this.state.object_type, this.state.object_code)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button" onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downloadHdfcSettlReportCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="hdfcSttlTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Store Name</th>
                                                <th>UTID</th>
                                                <th>Card Type</th>
                                                <th>Card Logo</th>
                                                <th>Tender Mode</th>
                                                <th>Business Line</th>
                                                <th>AcqBankCode</th>
                                                <th>Acquiring Bank</th>
{/*                                                 <th>Issuer Bank</th> */}
                                                <th>Txn Timestamp</th>
                                                <th>Edc Amount</th>
                                                <th>Txn Amount</th>
                                                <th>MDR</th>
                                                <th>MDR Amount</th>
                                                <th>GST On MDR</th>
                                                <th>Processing Fee Amount</th>
                                                <th>GST On Proc Fee</th>
                                                <th>EMI Processing Fee</th>
                                                <th>GST On EMI Fee</th>
                                                <th>EMI Instant Discount</th>
                                                <th>Chargeback Amount</th>
                                                <th>Rent Amount</th>
                                                <th>GST On Rent Amount</th>
                                                <th>Rental Charge Amount</th>
                                                <th>Bank Received Amount</th>
                                                <th>Final Txfr Amount</th>
                                                <th>Commission</th>
                                                <th>Narration</th>
                                                <th>Chq/RefNo</th>
                                                <th>beneficiary_status</th>
                                                <th>status</th>
                                                <th>Settlement Datetime</th>
                                                <th>Installation Fee</th>
                                                <th>Transaction Amount</th>
                                                <th>Bank MPR</th>
                                                <th>Bank Amount</th>
                                                <th>bankdiff</th>
                                                <th>txn_timestamp</th>
                                                <th>remarks</th>
                                                <th>adjustment_amount</th>
                                                <th>cardtype</th>
                                                <th>CRISP Status</th>
                                                <th>Genie Cash Rate</th>
                                                <th>Genie Cash Fee</th>
                                                <th>GST on Genie Cash Fee</th>
                                                <th>Innoviti Convenience Fee</th>
                                                <th>card_category</th>
                                                <th>mdr_cost</th>
                                                <th>mdr_cost_rate_percentage</th>
                                            </tr>
                                            </thead>
                                            <tbody></tbody>
                                        </table>
                                    </div>
                                    <DownloadAllReport ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        currentMenu: (name) => { dispatch({type:'change_menu',payload:name}) }
    }
};
export default connect(null, mapDispatchToProps)(HdfcSettlementReport);
